module.exports = __webpack_public_path__ + "img/bg_function02_3_m.8ac8d933.png";